import { AstraTooltip, astraTwMerge } from '~/astra'
import { ButtonTag } from '~/components'
import { Location, PractitionerStatusDefinition } from '~/storm'

type StatusProps = {
    entity: PractitionerStatusDefinition
}

type LocationProps = {
    entity: Location
}

type Props = (StatusProps | LocationProps) & {
    activityType: 'create' | 'delete' | 'update'
}

export const StatusLocationIcon = (props: Props) => {
    const { entity } = props
    const isPractitionerStatusDefinition = entity.entity_type === 'practitioner_status_definition'
    const tooltipContent = isPractitionerStatusDefinition ? entity.title : entity.room_code
    const fillType = isPractitionerStatusDefinition ? 'all' : 'none'
    const colorType = isPractitionerStatusDefinition ? entity.color : 'room'
    const label = isPractitionerStatusDefinition ? entity.title : entity.room_code
    const sizeStyle = isPractitionerStatusDefinition ? 'h-6 w-6' : 'h-6 w-12'
    const rotationStyle = isPractitionerStatusDefinition ? 'h-8 rotate-45' : 'h-[53px] rotate-[63deg]' // pythagoras, using sizes above
    return (
        <div className="flex items-center justify-center">
            <div className="px-3">
                <AstraTooltip tooltipContent={tooltipContent}>
                    <div className="relative overflow-hidden rounded">
                        <ButtonTag fillType={fillType} className={sizeStyle} colorType={colorType} label={label} disableHover />
                        {props.activityType === 'delete' && (
                            <div
                                className={astraTwMerge(
                                    'absolute left-[50%] top-[50%] w-0 translate-x-[-50%] translate-y-[-50%] rounded-xl border-l-[2px] border-strong opacity-80',
                                    rotationStyle
                                )}
                            />
                        )}
                    </div>
                </AstraTooltip>
            </div>
        </div>
    )
}
